import { Injectable, inject } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { BehaviorSubject, Subject, lastValueFrom } from 'rxjs';

import { QueueJobType, QueuePendingOperation } from '@models/api';
import {
  ModuleConfigDialogResult,
  ModuleConfigDialogTarget,
} from '@module-instance/modules/dialogs/module-config/common';
import { ModuleConfigDialogService } from '@module-instance/modules/dialogs/module-config/module-config-dialog.service';
import { NavigationService, QueueNotificationService } from '@shared/services';
import { PredefinedDictionaryKey } from '@signal-store/models';
import { ContextInfo } from '@system/context/context.model';

export type RefreshFromJs = {
  context: boolean;
  user: boolean;
  tenants: boolean;
  menu: boolean;
  emailCount: boolean;
};
@Injectable({
  providedIn: 'root',
})
export class JsToNgService {
  private navigator = inject(NavigationService);
  private moduleConfigDialog = inject(ModuleConfigDialogService);
  private queueNotificationService = inject(QueueNotificationService);

  refreshUser = new Subject<boolean>();
  context = new BehaviorSubject<ContextInfo>(undefined);
  closedModalData = new Subject<unknown>();
  refreshFromJsData = new BehaviorSubject<RefreshFromJs>({
    context: false,
    user: false,
    tenants: false,
    menu: false,
    emailCount: false,
  });
  invalidateList = new Subject<PredefinedDictionaryKey>();

  triggerRefresh(refreshObj: RefreshFromJs) {
    this.refreshFromJsData.next(refreshObj);
  }

  setContext(context: ContextInfo) {
    this.context.next(context);
  }

  dialogClosed(dialogData: unknown) {
    this.closedModalData.next(dialogData);
  }

  invalidateListData(listName: PredefinedDictionaryKey) {
    this.invalidateList.next(listName);
  }

  navigate(route: string[], extras?: NavigationExtras) {
    this.navigator.tenantNavigate(route, extras);
  }

  openModuleSettings(module: ModuleConfigDialogTarget): Promise<ModuleConfigDialogResult> {
    return lastValueFrom(this.moduleConfigDialog.openLegacyModuleSettings(module), { defaultValue: null });
  }

  registerQueueOperation(operation: QueuePendingOperation, notifyContinueInBackground = false) {
    this.queueNotificationService.registerOperation(operation);
    if (notifyContinueInBackground && operation?.jobType) {
      this.queueNotificationService.notifyContinueInBackground(operation.jobType as QueueJobType);
    }
  }
}
